import "../omega-theme.augmentation";
import { defineTheme, type ThemeDefinition } from "@omega/theme";

import { MOBILE_THEME } from "./mobile.theme";

/**
 * Закат — тёплая янтарно-оранжевая гамма (по мотивам nbp Sunset).
 */
export const SUNSET_THEME: ThemeDefinition = defineTheme(
    {
        id: "sunset",
        name: "Закат",
        scheme: "light",
        tokens: {
            color: {
                text: {
                    primary: "#3D2914",
                    secondary: "#8B5A2B",
                    disabled: "#A08060",
                    emphasis: "#2A1A0C",
                    inverse: "#FFFFFF",
                    danger: "#C41E3A",
                },
                background: { default: "#FBF6F0" },
                surface: {
                    base: "#FFFFFF",
                    hover: "#F5E8DC",
                    header: "#F0D4C0",
                    modal: "#FDF8F5",
                    disabled: "#F0E6DC",
                    selected: "#FAF0E8",
                },
                border: {
                    default: "#C45C26",
                    focus: "#8B4513",
                    muted: "#F0D4C0",
                    danger: "#C41E3A",
                    disabled: "#E0C8B4",
                },
                accent: {
                    main: "#C45C26",
                    contrastText: "#FFFFFF",
                },
                danger: { main: "#C41E3A" },
                success: { main: "#2E7D32" },
                warning: {
                    main: "#D4A017",
                    contrastText: "#3D2914",
                },
                neutral: {
                    main: "#3D2914",
                    contrastText: "#FFFFFF",
                },
                status: {
                    success: "#2E7D32",
                    successSurface: "#DCEFDD",
                    warningSurface: "#FFF0D0",
                    error: "#C41E3A",
                    errorSurface: "#F9D8DE",
                    info: "#B8860B",
                    infoSurface: "#F5E8DC",
                },
                alert: {
                    success: "#2E7D32",
                },
                skeleton: {
                    base: "#F0D4C0",
                    highlight: "#F5E8DC",
                },
            },
        },
    },
    { base: MOBILE_THEME },
);
